import * as React from 'react';
import { mergeClasses } from '@fluentui/react-components';
import { useLocationAnimatedStyles } from './LocationAnimated.styles';
const SvgLocationAnimated = (props)=>{
    const classes = useLocationAnimatedStyles();
    const [animState, setAnimState] = React.useState(0);
    const onMouseEnter = React.useCallback(()=>{
        setAnimState(1);
    }, [
        setAnimState
    ]);
    const onMouseLeave = React.useCallback(()=>{
        setAnimState(2);
    }, [
        setAnimState
    ]);
    return /*#__PURE__*/ React.createElement("span", {
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave
    }, /*#__PURE__*/ React.createElement("svg", {
        width: "20px",
        height: "20px",
        viewBox: "0 0 20 20",
        xmlns: "http://www.w3.org/2000/svg",
        ...props
    }, /*#__PURE__*/ React.createElement("g", {
        className: mergeClasses(classes.dots, animState === 1 && classes.dotsOver)
    }, /*#__PURE__*/ React.createElement("rect", {
        className: mergeClasses(animState === 1 && classes.lineOver),
        x: "4",
        y: "4",
        width: "11.5",
        height: "11.5",
        fill: "none"
    }), /*#__PURE__*/ React.createElement("circle", {
        cx: "4",
        cy: "4",
        r: "2.5"
    }), /*#__PURE__*/ React.createElement("circle", {
        cx: "15.5",
        cy: "4",
        r: "2.5"
    }), /*#__PURE__*/ React.createElement("circle", {
        cx: "4",
        cy: "15.5",
        r: "2.5"
    }), /*#__PURE__*/ React.createElement("circle", {
        cx: "15.5",
        cy: "15.5",
        r: "2.5"
    })), /*#__PURE__*/ React.createElement("g", {
        className: mergeClasses(animState === 1 && classes.leavesOver),
        transform: "translate(0.5 0.5)"
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M 5.59 2.58 a 3.01 3.01 90 1 0 0 6.02 h 2.58 a 0.43 0.43 90 0 0 0.43 -0.43 v -2.58 A 3.01 3.01 90 0 0 5.59 2.58",
        className: mergeClasses(classes.leaf, animState === 1 && classes.leafOver, animState === 1 && classes.leaf1Over, animState === 2 && classes.leafOut, animState === 2 && classes.leaf1Out)
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M 5.59 16.48 a 3.01 3.01 90 1 1 0 -6.02 h 2.58 c 0.258 0 0.43 0.172 0.43 0.43 v 2.58 c 0 1.72 -1.376 3.01 -3.01 3.01",
        className: mergeClasses(classes.leaf, animState === 1 && classes.leafOver, animState === 1 && classes.leaf2Over, animState === 2 && classes.leafOut, animState === 2 && classes.leaf2Out)
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M 16.48 5.59 a 3.01 3.01 90 1 0 -6.02 0 v 2.58 c 0 0.258 0.172 0.43 0.43 0.43 h 2.58 c 1.72 0 3.01 -1.376 3.01 -3.01",
        className: mergeClasses(classes.leaf, animState === 1 && classes.leafOver, animState === 1 && classes.leaf3Over, animState === 2 && classes.leafOut, animState === 2 && classes.leaf3Out)
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M 13.47 16.48 a 3.01 3.01 90 1 0 0 -6.02 h -2.58 c -0.258 0 -0.43 0.172 -0.43 0.43 v 2.58 c 0 1.72 1.376 3.01 3.01 3.01",
        className: mergeClasses(classes.leaf, animState === 1 && classes.leafOver, animState === 1 && classes.leaf4Over, animState === 2 && classes.leafOut, animState === 2 && classes.leaf4Out)
    }))));
};
export default SvgLocationAnimated;
